class HatMainProduct {
  constructor(section) {
    this.section = section;
    this.unitPrice = Number(section.dataset.unitPrice || 0);
    this.productAvailable = section.dataset.productAvailable === 'true';
    this.moneyFormat = section.dataset.moneyFormat || '${{amount}}';
    this.quantity = section.querySelector('[data-hat-quantity]');
    this.addLabel = section.querySelector('[data-hat-add-label]');
    this.shipping = section.querySelector('[data-hat-shipping-status]');
    this.initGallery();
    this.initQuantity();
    this.updatePurchase();
  }

  initGallery() {
    const panels = [...this.section.querySelectorAll('.belt-product__media-panel')];
    this.section.querySelectorAll('[data-hat-media-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.classList.contains('belt-product__thumb--video') && window.matchMedia('(max-width: 749px)').matches) {
          if (thumb.classList.contains('is-playing')) return;
          const source = panels.find((panel) => panel.id === thumb.dataset.hatMediaTarget)?.querySelector('video');
          if (!source) return;
          const video = source.cloneNode(true);
          video.controls = true;
          video.preload = 'auto';
          video.className = 'belt-product__mobile-video';
          thumb.classList.add('is-playing');
          thumb.replaceChildren(video);
          video.play().catch(() => {});
          return;
        }
        panels.forEach((panel) => {
          const active = panel.id === thumb.dataset.hatMediaTarget;
          panel.hidden = !active;
          if (!active) panel.querySelector('video')?.pause();
        });
        this.section.querySelectorAll('[data-hat-media-target]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  }

  initQuantity() {
    this.section.querySelector('[data-hat-quantity-minus]')?.addEventListener('click', () => this.setQuantity(this.value() - 1));
    this.section.querySelector('[data-hat-quantity-plus]')?.addEventListener('click', () => this.setQuantity(this.value() + 1));
    this.quantity?.addEventListener('change', () => this.setQuantity(this.value()));
  }

  value() { return Math.max(1, Math.min(99, Number(this.quantity?.value || 1))); }
  setQuantity(value) { if (this.quantity) this.quantity.value = Math.max(1, Math.min(99, value)); this.updatePurchase(); }

  updatePurchase() {
    const total = this.unitPrice * this.value();
    if (this.addLabel && this.productAvailable) {
      this.addLabel.textContent = `Add to cart · ${this.formatMoney(total)}`;
    }
    this.updateShipping(total);
  }

  updateShipping(total) {
    if (!this.shipping) return;
    const threshold = Math.max(0, Number(this.shipping.dataset.freeShippingThreshold || 0));
    const remaining = Math.max(0, threshold - total);
    const unlocked = threshold === 0 || remaining === 0;
    const message = this.shipping.querySelector('[data-hat-shipping-message]');
    const progress = this.shipping.querySelector('[data-hat-shipping-progress]');
    this.shipping.classList.toggle('is-unlocked', unlocked);
    const lockedText = this.shipping.dataset.lockedText || "You're [amount] from free shipping";
    const unlockedText = this.shipping.dataset.unlockedText || "You've unlocked free shipping";
    if (message) message.textContent = unlocked ? unlockedText : lockedText.replace('[amount]', this.formatMoney(remaining));
    if (progress) { progress.hidden = unlocked; progress.querySelector('i').style.width = `${threshold ? Math.min(100, total / threshold * 100) : 100}%`; }
    const start = this.addBusinessDays(new Date(), Number(this.shipping.dataset.businessDays || 5));
    const end = this.addBusinessDays(start, Number(this.shipping.dataset.deliveryWindow || 1));
    const delivery = this.shipping.querySelector('[data-hat-delivery-message]');
    if (delivery) delivery.innerHTML = `Ships <b>within ${Number(this.shipping.dataset.shippingHours || 24)} hours</b>. Estimated arrival <b>${this.dateLabel(start)}</b> to <b>${this.dateLabel(end)}</b>.`;
  }

  addBusinessDays(date, days) {
    const result = new Date(date); let added = 0;
    while (added < days) { result.setDate(result.getDate() + 1); if (result.getDay() !== 0 && result.getDay() !== 6) added += 1; }
    return result;
  }
  dateLabel(date) { return new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(date); }
  formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, this.moneyFormat);
    const value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    return this.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
}

const initHatMainProducts = (scope = document) => scope.querySelectorAll('[data-hat-main-product]').forEach((section) => {
  if (!section.hatMainProduct) section.hatMainProduct = new HatMainProduct(section);
});
document.addEventListener('DOMContentLoaded', () => initHatMainProducts());
document.addEventListener('shopify:section:load', (event) => initHatMainProducts(event.target));
